import {
  LayoutDashboard,
  Users,
  Building2,
  Wallet,
  Truck,
  GitBranch,
  Timer,
  Gauge,
  ShieldAlert,
  Monitor,
  AlertOctagon,
  Scale,
  Cog,
  Workflow,
  UserCog,
  Briefcase,
  UserPlus,
  CreditCard,
  GraduationCap,
  Headphones,
  FileCheck,
  Network,
  HeartHandshake,
  RefreshCw,
  PiggyBank,
  Gavel,
  Telescope,
  PieChart,
  Sparkles,
  Bot,
  Cpu,
  AlertTriangle,
  Activity,
  MessageSquare,
  Boxes,
  Landmark,
  TrendingUp,
  Rocket,
} from 'lucide-react';

/** Hierarchical sidebar: Cost Optimization & Automation (M16). */
export function getCostOptimizationNavChildren() {
  return [
    {
      path: '/cost-optimization-automation/section-visibility',
      label: 'Cost Visibility, Control & Efficiency Monitoring',
      icon: PieChart,
      children: [
        { path: '/cost-optimization-automation/dashboard', label: 'Cost Dashboard', icon: LayoutDashboard },
        { path: '/cost-optimization-automation/workforce-cost', label: 'Workforce Cost Visibility', icon: Users },
        { path: '/cost-optimization-automation/hr-operations-cost', label: 'HR Operations Cost Monitoring', icon: Building2 },
        { path: '/cost-optimization-automation/budget-spend-control', label: 'Budget & Spend Control', icon: Wallet },
        { path: '/cost-optimization-automation/vendor-cost', label: 'Vendor & Third-Party Cost', icon: Truck },
        { path: '/cost-optimization-automation/process-cost-mapping', label: 'Process Cost Mapping', icon: GitBranch },
        { path: '/cost-optimization-automation/manual-effort-overhead', label: 'Manual Effort & Admin Overhead', icon: Timer },
        { path: '/cost-optimization-automation/productivity-efficiency', label: 'Productivity & Efficiency Monitoring', icon: Gauge },
        { path: '/cost-optimization-automation/compliance-penalty-cost', label: 'Compliance & Penalty Cost Tracking', icon: ShieldAlert },
        { path: '/cost-optimization-automation/tool-cost-visibility', label: 'Technology & Tool Cost Visibility', icon: Monitor },
        { path: '/cost-optimization-automation/policy-exception-leakage', label: 'Policy, Exception & Leakage Monitoring', icon: AlertOctagon },
        { path: '/cost-optimization-automation/cost-benchmarking', label: 'Cost Analytics & Benchmarking', icon: Scale },
      ],
    },
    {
      path: '/cost-optimization-automation/section-automation',
      label: 'Automation, Productivity & Process Optimization',
      icon: Workflow,
      children: [
        { path: '/cost-optimization-automation/process-automation', label: 'Process Automation Management', icon: Cog },
        { path: '/cost-optimization-automation/hr-workflow-automation', label: 'HR Workflow Automation', icon: Workflow },
        { path: '/cost-optimization-automation/self-service-optimization', label: 'Employee Self-Service Optimization', icon: UserCog },
        { path: '/cost-optimization-automation/recruitment-automation', label: 'Recruitment & Hiring Automation', icon: Briefcase },
        { path: '/cost-optimization-automation/onboarding-lifecycle-automation', label: 'Onboarding & Lifecycle Automation', icon: UserPlus },
        { path: '/cost-optimization-automation/payroll-benefits-automation', label: 'Payroll & Benefits Automation', icon: CreditCard },
        { path: '/cost-optimization-automation/training-automation', label: 'Training & Learning Automation', icon: GraduationCap },
        { path: '/cost-optimization-automation/helpdesk-query-automation', label: 'Support, Helpdesk & Query Automation', icon: Headphones },
        { path: '/cost-optimization-automation/document-compliance-automation', label: 'Document & Compliance Automation', icon: FileCheck },
        { path: '/cost-optimization-automation/resource-allocation-automation', label: 'Resource & Allocation Automation', icon: Network },
        { path: '/cost-optimization-automation/performance-engagement-automation', label: 'Performance & Engagement Automation', icon: HeartHandshake },
        { path: '/cost-optimization-automation/process-reengineering', label: 'Productivity Improvement & Process Reengineering', icon: RefreshCw },
        { path: '/cost-optimization-automation/automation-roi-savings', label: 'Automation ROI & Savings Tracking', icon: PiggyBank },
        { path: '/cost-optimization-automation/automation-governance', label: 'Workflow, Controls & Governance for Automation', icon: Gavel },
      ],
    },
    {
      path: '/cost-optimization-automation/section-predictive',
      label: 'Predictive Savings, AI Optimization & Strategic Cost Intelligence',
      icon: Sparkles,
      children: [
        { path: '/cost-optimization-automation/cost-forecasting', label: 'Cost Forecasting', icon: Telescope },
        { path: '/cost-optimization-automation/cost-driver-analysis', label: 'Cost Driver Analysis', icon: PieChart },
        { path: '/cost-optimization-automation/savings-opportunities', label: 'Savings Opportunity Intelligence', icon: TrendingUp },
        { path: '/cost-optimization-automation/ai-cost-recommendations', label: 'AI-Powered Cost Optimization Recommendations', icon: Cpu },
        { path: '/cost-optimization-automation/ai-productivity-recommendations', label: 'AI Productivity & Automation Recommendations', icon: Bot },
        { path: '/cost-optimization-automation/cost-overrun-risk', label: 'Risk of Cost Overrun Prediction', icon: AlertTriangle },
        { path: '/cost-optimization-automation/efficiency-risk', label: 'Workforce Efficiency Risk Prediction', icon: Activity },
        { path: '/cost-optimization-automation/ai-copilot', label: 'AI Copilot for Cost & Automation Queries', icon: MessageSquare },
        { path: '/cost-optimization-automation/scenario-modeling', label: 'Scenario Modeling & What-if Cost Planning', icon: Boxes },
        { path: '/cost-optimization-automation/strategic-cost-intelligence', label: 'Strategic Cost Intelligence', icon: Landmark },
        { path: '/cost-optimization-automation/executive-decision-support', label: 'Executive Decision Support', icon: LayoutDashboard },
        { path: '/cost-optimization-automation/continuous-improvement', label: 'Continuous Improvement & Optimization Tracking', icon: RefreshCw },
        { path: '/hr-copilot', label: 'HR Copilot (global)', icon: Bot },
        { path: '/transformation', label: 'Transformation', icon: Rocket },
      ],
    },
  ];
}
